/**
 * JunctionOffIcon/index.js
 * desc: system icon for disabled/missing junction
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const JunctionOffIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="junction-off icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.junctionOff.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg"><path d="M23 21.481L21.481 23l-8.69-8.69h-.554v7.976h-2.062v-7.975H3.95c-.33 0-.66-.085-.825-.255l-1.731-1.867 1.731-1.824c.165-.17.495-.255.825-.255h4.642L6.385 7.905h-1.9c-.608 0-.857 0-.96-.122-.07-.085-.07-.229-.07-.472V4.974L0 1.519 1.519 0 23 21.481zM10.175 3.704h-1.73l4.2 4.2h5.776c.33 0 .66-.084.825-.254l1.731-1.824-1.731-1.867c-.165-.17-.495-.255-.825-.255h-6.184v-2.63h-2.062v2.63zM17.885 10.11h-3.033l4.025 4.026c.039-.088.039-.22.039-.42v-3.011c0-.595 0-.595-1.031-.595z"/></svg>
    </IconButton>
);


export default JunctionOffIcon;
